export var SupportedLanguages;
(function (SupportedLanguages) {
    SupportedLanguages["Bash"] = "bash";
    SupportedLanguages["Cpp"] = "cpp";
    SupportedLanguages["Csharp"] = "csharp";
    SupportedLanguages["Css"] = "css";
    SupportedLanguages["Graphql"] = "graphql";
    SupportedLanguages["Html"] = "html";
    SupportedLanguages["Javascript"] = "javascript";
    SupportedLanguages["Powershell"] = "powershell";
    SupportedLanguages["Python"] = "python";
    SupportedLanguages["Shell"] = "shell";
    SupportedLanguages["Sql"] = "sql";
    SupportedLanguages["Typescript"] = "typescript";
})(SupportedLanguages || (SupportedLanguages = {}));
export const SupportedLanguagesDetails = {
    [SupportedLanguages.Bash]: {
        label: 'Bash',
        grammar: 'bash'
    },
    [SupportedLanguages.Cpp]: {
        label: 'C++',
        grammar: 'cpp'
    },
    [SupportedLanguages.Csharp]: {
        label: 'C#',
        grammar: 'csharp'
    },
    [SupportedLanguages.Css]: {
        label: 'CSS',
        grammar: 'css'
    },
    [SupportedLanguages.Graphql]: {
        label: 'GraphQL',
        grammar: 'graphql'
    },
    [SupportedLanguages.Html]: {
        label: 'HTML',
        grammar: 'html'
    },
    [SupportedLanguages.Javascript]: {
        label: 'JavaScript',
        grammar: 'javascript'
    },
    [SupportedLanguages.Powershell]: {
        label: 'PowerShell',
        grammar: 'powershell'
    },
    [SupportedLanguages.Python]: {
        label: 'Python',
        grammar: 'python'
    },
    [SupportedLanguages.Shell]: {
        label: 'Shell',
        grammar: 'shell-script'
    },
    [SupportedLanguages.Sql]: {
        label: 'SQL',
        grammar: 'sql'
    },
    [SupportedLanguages.Typescript]: {
        label: 'TypeScript',
        grammar: 'typescript'
    }
};
//# sourceMappingURL=languages.js.map